import type { MetaFunction } from "remix";

export const meta: MetaFunction = () => {
  return {
    title: `About | Ryan Chenkie`,
  };
};

const About = () => {
  return (
    <>
      <div className="border-r border-l border-gray-200 p-8 flex justify-center h-screen mt-10">
        <div className="sm:w-1/2">
          <h1 className="text-5xl text-center font-title font-bold text-gray-800">
            👋 Hey, I'm Ryan
          </h1>
          <img
            className="rounded-full w-24 m-auto mt-12"
            src="https://res.cloudinary.com/dkpz9r2q7/image/upload/v1640747191/ryan_zobbvq.jpg"
            alt="avatar"
          />
          <div className="mt-4 text-center text-xl prose prose-headings:underline prose-headings:font-serif prose-p:font-body prose-li:font-body lg:prose-xl p-8 m-auto">
            <p>I'm a fullstack software developer from Ottawa, Canada.</p>
            <p>
              I teach other developers stuff like{" "}
              <a href="https://reactsecurity.io" target="_blank">
                security for React apps
              </a>{" "}
              and make{" "}
              <a href="https://youtube.com/ryanchenkie" target="_blank">
                videos on YouTube
              </a>
              .
            </p>
            <p>
              <a href="https://twitter.com/ryanchenkie" target="_blank">
                Follow me on Twitter
              </a>{" "}
              and say hi!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
